<app-vista-seguridad>
  <section class="col-12 p-4 rounded bg-white m-auto shadow">
    <header class="mb-4">
      <h2>Crea tu cuenta</h2>
    </header>
    <form [formGroup]="formRegistroCuenta" (ngSubmit)="openModal()" [autocomplete]="false">
      <div class="form-row mb-4">
        <div class="col-md-6 col-sm-12 form-group m-auto">
          <label for="nombre" class="small text-secondary required">Nombre de usuario</label>
          <input id="nombre" formControlName="usuario" class="form-control" type="text">
          <div id="mensaje"
            *ngIf="!formRegistroCuenta.controls.usuario.valid  && (formRegistroCuenta.get('usuario').dirty)">
            <p class="small text-danger mt-1 position-absolute font-weight-bold font-weight-bold" text-right>Caracter
              especial no permitido</p>
          </div>
        </div>
        <div class="col-md-6 col-sm-12 form-group m-auto">
          <label for="tipo_identificacion" class="small text-secondary required">Tipo identificación</label>
          <select id="tipo_identificacion" formControlName="tipo_identificacion_id" class="form-control"
            (change)="onValidarPrestador()">
            <ng-container *ngFor="let item of tipos_identificaciones">
              <option [ngValue]="item.tipo_identificacion_id">{{item.descripcion}}</option>
            </ng-container>
          </select>
        </div>
      </div>
      <div class="form-row mb-4">
        <div class="col-md-6 col-sm-12 form-group m-auto">
          <label for="numero_identificacion" class="small text-secondary required">Numero de identificación</label>
          <input id="numero_identificacion" formControlName="numero_identificacion" (change)="onValidarPrestador()"
            class="form-control" type="text">
          <div id="mensaje"
            *ngIf="!formRegistroCuenta.controls.numero_identificacion.valid  && (formRegistroCuenta.get('numero_identificacion').dirty)">
            <p class="small text-danger mt-1 position-absolute font-weight-bold font-weight-bold" text-right>Dígite
              únicamente valores numéricos</p>
          </div>
        </div>
        <div class="col-md-6 col-sm-12 form-group m-auto">
          <label for="digito_verificacion" class="small text-secondary required">Digito de verificación</label>
          <input id="digito_verificacion" formControlName="digito_verificacion" (change)="onValidarPrestador()"
            class="form-control" type="text">
          <!-- <div id="mensaje"
            *ngIf="!formRegistroCuenta.controls.digito_verificacion.valid  && (formRegistroCuenta.get('digito_verificacion').dirty)">
            <p class="small text-danger mt-1 position-absolute font-weight-bold font-weight-bold" text-right>Dígite
              únicamente valores numéricos</p><br>
          </div> -->
          <div id="mensaje">
            <span class="small text-danger mt-1 position-absolute font-weight-bold font-weight-bold" *ngIf="formRegistroCuenta.get('digito_verificacion')?.hasError('pattern')&& !formRegistroCuenta.get('digito_verificacion')?.hasError('maxlength')  && (formRegistroCuenta.get('digito_verificacion').touched || formRegistroCuenta.get('digito_verificacion').dirty)">
              <p> *únicamente valores numéricos</p>
               </span>
             <span class="small text-danger mt-1 position-absolute font-weight-bold font-weight-bold" *ngIf="formRegistroCuenta.get('digito_verificacion')?.hasError('maxlength') && (formRegistroCuenta.get('digito_verificacion').touched || formRegistroCuenta.get('digito_verificacion').dirty)">
              <p>*Se permite solo un digito</p>
              </span>
          </div>
        </div>
      </div>
      <div class="form-row mb-4" formGroupName="contrasenaGroup">
        <div class="col-md-6 col-sm-12 form-group m-auto">
          <label for="contrasena" class="small text-secondary required">Contraseña</label>
          <input id="contrasena" formControlName="clave_acceso" class="form-control" type="password"
            ngbTooltip="Usa al menos 8 caracteres, un carácter especial (%$+!.), una mayúscula y un número.">
          <div id="mensaje"
            *ngIf="!formRegistroCuenta.get('contrasenaGroup').get('clave_acceso').valid && (formRegistroCuenta.get('contrasenaGroup').get('clave_acceso').dirty)">
            <p class="small text-danger mt-1 position-absolute font-weight-bold" text-right>Contraseña debil</p>
          </div>
        </div>
        <div class="col-md-6 col-sm-12 form-group m-auto">
          <label for="contrasena_confirmar" class="small text-secondary required">Confirmar Contraseña</label>
          <input id="contrasena_confirmar" formControlName="clave_acceso_confirmacion" class="form-control"
            type="password">
          <div id="mensaje"
            *ngIf="!formRegistroCuenta.controls.contrasenaGroup.valid && formRegistroCuenta.get('contrasenaGroup') && (formRegistroCuenta.get('contrasenaGroup').dirty)">
            <p class="small text-danger mt-1 position-absolute font-weight-bold" text-right>Contraseñas no coinciden</p>
          </div>
        </div>

      </div>
      <div class="form-row mb-4">
        <div class="col-md-6 col-sm-12 form-group m-auto">
          <label for="nombre_represent_legal" class="small text-secondary required">Nombre representante legal/Persona
            natural</label>
          <input id="nombre_represent_legal" formControlName="nombre_representante_legal" class="form-control"
            type="text">
        </div>
        <div class="col-md-6 col-sm-12 form-group m-auto">
          <label for="correo" class="small text-secondary required">Correo electrónico</label>
          <input id="correo" formControlName="correo_electronico" class="form-control" type="text">
        </div>
      </div>
      <div class="form-row mb-4">
        <div class="col-md-6 col-sm-12 form-group m-auto">
          <label for="tipo_prestador" class="small text-secondary required">En calidad de</label>
          <input id="tipo_prestador" formControlName="tipo_prestador" class="form-control" type="text">
        </div>
        <div class="col form-group m-auto">
        </div>
      </div>
      <div class="form-row mb-4">
        <div class="col">
          <div class="col form-group m-auto">
            <input id="recibir_notificacion" formControlName="permite_recibir_notificaciones" class="form-check-input"
              type="checkbox">
            <label for="recibir_notificacion" class="form-check-label small">Acepta recibir notificaciones vía correo
              electrónico del estado de sus solicitudes</label>
          </div>
        </div>
      </div>
      <div class="form-row mb-4">
        <div class="col">
          <div class="col form-group m-auto">
            <input id="aceptar_terminos" formControlName="acepta_terminos_condiciones" class="form-check-input"
              type="checkbox">
            <label for="aceptar_terminos" class="form-check-label small pointer" (click)="onNavigationTerminos()">{{texto_aceptacion_terminos}}</label>
          </div>
        </div>
      </div>
      <div class="form-row mb-2">
        <div class="col-12 text-center">
          <re-captcha formControlName="captcha" class="d-inline-block"></re-captcha>
        </div>
      </div>
      <div class="form-row">
        <div class="col form-group d-flex justify-content-center">
          <button type="submit" [disabled]="!formRegistroCuenta.valid"
            class="btn w-50 text-white registro-cuenta-btn-principal ">Crear
            cuenta</button>
        </div>
      </div>
    </form>
  </section>
</app-vista-seguridad>
